import { useQuery } from '@apollo/client';
import { Link } from 'react-router';
import { ApolloProviderV4 } from '~/apollo/client-v4';
import { graphql } from '~/apollo/generated/v4';
import { FilterSearch } from '~/components/common/FilterSearch';
import { ListGroup } from '~/components/common/ListGroup';
import { NoItemsAlert } from '~/components/common/NoItemsAlert';
import { PageHeading } from '~/components/common/PageHeading';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { useSortFilter } from '~/hooks/data';
import { otherWikiDetailRoute } from '~/paths';

const OTHER_WIKI_INDEX_PAGE = graphql(`
  query OtherWikiIndexPage {
    otherWikiList(first: 999999) {
      results {
        ...otherWikiParts
      }
    }
  }
`);

export default function OtherWikiListPage() {
  return (
    <ApolloProviderV4>
      <OtherWikiListPageInner />
    </ApolloProviderV4>
  );
}

function OtherWikiListPageInner() {
  const { data, loading } = useQuery(OTHER_WIKI_INDEX_PAGE);

  const { items, filterSearchProps } = useSortFilter(
    data?.otherWikiList?.results ?? [],
    'title',
    'title',
    'otherWikiList',
  );

  return (
    <div className="space-y-4">
      <PageHeading className="mt-0">Other Articles</PageHeading>
      <p className="mb-4">
        The wiki articles in this section describe the SAFARI standard aside
        from the depositional schema, and other related topics.
      </p>

      <FilterSearch {...filterSearchProps} />

      {loading ? (
        <SpinnerPlaceholder />
      ) : (
        <NoItemsAlert show={!items.length} entity="other wiki pages" />
      )}

      <ListGroup>
        {items.map(otherWiki => (
          <ListGroup.Item key={otherWiki.id}>
            <Link
              to={otherWikiDetailRoute(parseInt(otherWiki.id))}
              className="block p-1"
            >
              {otherWiki.title}
            </Link>
          </ListGroup.Item>
        ))}
      </ListGroup>
    </div>
  );
}
